import { createReducer, on } from '@ngrx/store';

import { StepAssigneeTableItem } from '@main-application/management/components/turnover-configuration/components/turnover-configuration-step-assignees/config/interfaces/step-assignee-table-item.interface';
import { PropertyAssignees } from '@main-application/management/components/turnover-configuration/components/turnover-configuration-step-assignees/config/interfaces/step-assignees';
import { UpdateStatus } from '@shared/enums/update-status';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import { RestWorkflowStepAssignmentModel } from '@shared/interfaces/rest-workflow-step-assignment-model.interface';

import {
  createResponsibleParties,
  createResponsiblePartiesFailure,
  createResponsiblePartiesSuccess,
  loadResponsibleParties,
  loadResponsiblePartiesFailure,
  loadResponsiblePartiesSuccess,
  resetAllUserList,
  resetAssigneesUpdateModel,
  resetAssigneesUpdateStatus,
  resetEditedCell,
  resetPropertyUser,
  setAllStepAssigneeList,
  setEditedCell,
  setUserRadioList,
  updatePropertyUser,
  updateResponsibleParties,
  updateResponsiblePartiesFailure,
  updateResponsiblePartiesSuccess,
} from '../actions/turnover-configuration-step-assignees.actions';

export const reponsiblePartiesFeatureKey = 'reponsibleParties';

export interface State {
  responsiblePartiesLoading: boolean;
  responsibleParties: RestWorkflowStepAssignmentModel[];

  createResponsiblePartiesOngoing: boolean;
  createResponsiblePartiesStatus: UpdateStatus;

  updateResponsiblePartiesOngoing: boolean;
  updateResponsiblePartiesStatus: UpdateStatus;

  updatedResponsibleParties: RestWorkflowStepAssignmentModel[];

  editedCellUUId: string;
  allUsers: IRadioButtonOption<number>[];
  propertyUsers: PropertyAssignees[];
  allStepAssigneeList: StepAssigneeTableItem[];
}

export const initialState: State = {
  responsiblePartiesLoading: false,
  responsibleParties: [],

  createResponsiblePartiesOngoing: false,
  createResponsiblePartiesStatus: null,

  updateResponsiblePartiesOngoing: false,
  updateResponsiblePartiesStatus: null,

  updatedResponsibleParties: [],

  editedCellUUId: null,
  allUsers: [],
  propertyUsers: [],
  allStepAssigneeList: [],
};

export const reducer = createReducer(
  initialState,
  on(loadResponsibleParties, (state, action) => ({ ...state, responsiblePartiesLoading: true })),
  on(setAllStepAssigneeList, (state, action) => ({
    ...state,
    ...action,
  })),
  on(loadResponsiblePartiesSuccess, (state, action) => ({
    ...state,
    responsibleParties: action.responsibleParties,
    responsiblePartiesLoading: false,
  })),
  on(loadResponsiblePartiesFailure, (state, action) => ({
    ...state,
    responsibleParties: [],
    responsiblePartiesLoading: false,
  })),

  on(createResponsibleParties, (state, action) => ({
    ...state,
    createResponsiblePartiesOngoing: true,
    createResponsiblePartiesStatus: UpdateStatus.UPDATE,
  })),
  on(createResponsiblePartiesSuccess, (state, action) => ({
    ...state,
    createResponsiblePartiesOngoing: false,
    createResponsiblePartiesStatus: UpdateStatus.OK,
    updatedResponsibleParties: action.createResponsibleParties,
  })),
  on(createResponsiblePartiesFailure, (state, action) => ({
    ...state,
    createResponsiblePartiesOngoing: false,
    createResponsiblePartiesStatus: UpdateStatus.ERROR,
    updatedResponsibleParties: [],
  })),

  on(updateResponsibleParties, (state, action) => ({
    ...state,
    updateResponsiblePartiesOngoing: true,
    updateResponsiblePartiesStatus: UpdateStatus.UPDATE,
  })),
  on(updateResponsiblePartiesSuccess, (state, action) => ({
    ...state,
    updateResponsiblePartiesOngoing: false,
    updateResponsiblePartiesStatus: UpdateStatus.OK,
    updatedResponsibleParties: action.updateResponsibleParties,
  })),
  on(updateResponsiblePartiesFailure, (state, action) => ({
    ...state,
    updateResponsiblePartiesOngoing: false,
    updateResponsiblePartiesStatus: UpdateStatus.ERROR,
    updatedResponsibleParties: [],
  })),

  on(resetAssigneesUpdateStatus, (state, action) => ({
    ...state,
    createResponsiblePartiesStatus: null,
    updateResponsiblePartiesStatus: null,
  })),

  on(resetAssigneesUpdateModel, (state, action) => ({
    ...state,
    updatedResponsibleParties: [],
  })),

  on(setEditedCell, (state, action) => ({
    ...state,
    editedCellUUId: action.uuid,
  })),
  on(resetEditedCell, (state, action) => ({
    ...state,
    editedCellUUId: null,
  })),

  on(setUserRadioList, (state, action) => ({
    ...state,
    allUsers: action.allUsers,
  })),
  on(resetAllUserList, (state, action) => ({
    ...state,
    allUsers: null,
  })),
  on(updatePropertyUser, (state, action) => ({
    ...state,
    propertyUsers: action.propertyUsers,
  })),
  on(resetPropertyUser, (state, action) => ({
    ...state,
    propertyUsers: [],
  }))
);
